// extracted by mini-css-extract-plugin
export default {"giftcardList":"GiftCardList_giftcardList__7tJG+"};